/* eslint no-eval: 0 */
import React, { LegacyRef } from 'react';
import { connect } from 'react-redux';
import { IDataStorage } from '../../core';
import Alert from '../alerts';
import { Button, Column, DataTable, Dialog, InputSwitch, OverlayPanel, Toolbar } from '../prime';
import { SelectModes, OrderModes, IPagination, IGridColumn, IGridCommand } from './model';
import { IPaginatedResponse } from '../../services/model/PaginatedResponse';
import { Loader } from '..';
import UserData from '../../services/userdata';
import styles from './index.module.scss';
import { DataTableProps, DataTableRowClickEventParams, DataTableRowEventParams } from 'primereact/datatable';
import { Player } from '../video';
import saveAs from 'file-saver';

interface IGridColumn2 {
  key: string;
  order: number;
  column?: IGridColumn;
  commands?: IGridCommand[];
}

export interface IGridProps {
  storage?: IDataStorage;
  syncGrid?: (grid:Index) => void;
  onContextMenu?: (e:DataTableRowEventParams, row: any) => void;
  onRowDoubleClick?: (e:DataTableRowClickEventParams) => void;

  // Misc
  name?: string;
  refTable?: LegacyRef<DataTable>,
  footer?: any;
  customHeader?: any;
  headerCommands?: (IGridCommand | undefined)[];
  columns?: (IGridColumn | undefined)[];
  columnCommands?: (IGridCommand | undefined)[];
  columnCommandsWidth?: string;
  className?: string;

  // Datos
  data: (pag?: IPagination, sort?: string, filters?: any) => Promise<IPaginatedResponse<any>>;
  dataKey?: string;
  autoLoad?: boolean;

  // Columnas
  children?: any;

  // Selección
  selectMode?: SelectModes;
  onSelect?: (data: any) => void;
  
  // Sort
  orderMode?: OrderModes;

  editorMode?: "row" | "cell";
  headerColumnGroup?: React.ReactNode;
  
  customProps?: DataTableProps;
}

interface IState {
  storage?: IDataStorage;

  // Misc
  name?: string;
  footer?: any;
  customHeader?: any;
  headerCommands?: (IGridCommand | undefined)[];
  columns?: (IGridColumn | undefined)[];
  columnCommands?: (IGridCommand | undefined)[];
  columnCommandsWidth?: string;
  allcolumns?: IGridColumn2[];
  activecolumns?: IGridColumn2[];
  className?: string;

  // Datos
  loading?: boolean;
  data?: IPaginatedResponse<any>;
  dataKey?: string;

  // Paginación
  paginacion?: IPagination;

  // Columnas
  children?: Column[];

  // Selección
  selectMode?: SelectModes;
  selected?: any;

  // Sort
  orderMode?: OrderModes;
  sort?: any;

  // Filters
  filters?: any;

  // elemento seleccionado con botón derecho
  contextMenuSelection?: any;

  showvideo?: boolean;
  
  editorMode?: string;
  headerColumnGroup?: React.ReactNode;

  customProps?: DataTableProps;
}

class Index extends React.Component<IGridProps, IState> {
  state : IState = {};
  GridOptionsPanel : OverlayPanel | null = null;

  componentDidMount = () => {
    this.props.syncGrid && this.props.syncGrid(this);
    Index.getDerivedStateFromProps(this.props, this.state);
    if (this.props.autoLoad === undefined || this.props.autoLoad === true)
      this.getData();
    this.getUserConfig();
  }
  static getDerivedStateFromProps = (p: IGridProps, s?: IState) : IState=> {
    let res : IState = { };
    if (p?.storage !== s?.storage) res.storage = p.storage;
    // Misc
    if (p?.name !== s?.name) res.name = p.name;
    if (p?.customHeader !== s?.customHeader) res.customHeader = p.customHeader;
    if (p?.headerCommands !== s?.headerCommands) res.headerCommands = p.headerCommands;
    if (p?.columns !== s?.columns) {
      res.columns = p.columns;
      if (s?.activecolumns && p.columns) {
        for(let i = 0; i< s.activecolumns.length ; i++) {
          const ca = s.activecolumns[i];
          if (ca.column) {
            const c = p.columns.find(p => ca.column && p?.field === ca.column?.field);
            if (c)
              ca.column.filterElement = c.filterElement;
          }
        }
      }
    }
    if (p?.columnCommands !== s?.columnCommands) res.columnCommands = p.columnCommands;
    if (p?.columnCommandsWidth !== s?.columnCommandsWidth) res.columnCommandsWidth = p.columnCommandsWidth;
    if (p?.className !== s?.className) res.className = p.className;
    // Datos
    if (p?.dataKey !== s?.dataKey) res.dataKey = p.dataKey;
    // Columnas
    if (p?.children !== s?.children) res.children = p.children;
    // Selección
    if (p?.selectMode !== s?.selectMode) res.selectMode = p.selectMode;
    // Sort
    if (p?.orderMode !== s?.orderMode) res.orderMode = p.orderMode;

    if (p?.editorMode !== s?.editorMode) res.editorMode = p.editorMode;
    if (p?.headerColumnGroup !== s?.headerColumnGroup) res.headerColumnGroup = p.headerColumnGroup;
    if (p?.customProps !== s?.customProps) res.customProps = p.customProps;
    return res;
  }

  getUserConfig = (reset?: boolean) => {
    // Se establece el valor default configurado en el codigo
    const activecolumns : IGridColumn2[] = [];
    if (this.state.columns)
      activecolumns.push(...this.state.columns.filter(c => !!c).map(c => ({ key: `COK${c?.order}`, order: c?.order ?? 99, column: c })).sort((a,b) => a.order - b.order));
    if (this.state.columnCommands)
      //order debe ser el "max+1"
      activecolumns?.push({ key: `CCK`, order: activecolumns.length + 1, commands: this.state.columnCommands.filter(c => !!c).map(c => c as IGridCommand) });
    this.setState({ activecolumns, allcolumns: activecolumns }); // por default se muestran todas
    
    if (reset) {
      UserData.set(`grid_${this.state.name ?? window.location.pathname}`, undefined);
      return;
    }

    UserData.get(`grid_${this.state.name ?? window.location.pathname}`)
      .then((data?: any[]) => {
        if (data && data.length > 0 && this.state.allcolumns) {
          const activecolumns : IGridColumn2[] = [];
          for(let i = 0 ; i < this.state.allcolumns.length; i++) {
            const ac = this.state.allcolumns[i];
            const cc = data.find(d => d.key === ac.key);
            if (cc) {
              activecolumns.push({ ...ac, ...{ order: cc.order }});
            }
          }
          this.setState({ activecolumns });
        }
      })
      .catch(err => Alert.error("Error Inesperado", "Error al obtener la configuración de Usuario de la grilla"));
  }

  getSort = (sort?: any) : string | undefined => {
    if (!sort) return undefined;

    if (sort.sortField && sort.sortOrder)
      return `${sort.sortField} ${sort.sortOrder === 1 ? 'asc' : 'desc'}`;
    
    if (sort.multiSortMeta)
      return (sort.multiSortMeta as any[]).map(p => `${p.field} ${p.order === 1 ? 'asc' : 'desc'}`).join(', ');
  }

  getData = (pageIndex?: number, pageSize?: number, gridsort?: any, gridfilters?: any) => {
    let { paginacion, sort, filters } = this.state;

    if (!paginacion) paginacion = { pageIndex: 0, pageSize: 10 };
    paginacion.pageIndex = pageIndex !== undefined ? pageIndex : paginacion.pageIndex;
    paginacion.pageSize = pageSize !== undefined ? pageSize : paginacion.pageSize;
    sort = gridsort === undefined ? sort : gridsort;
    filters = gridfilters === undefined ? filters : gridfilters;

    this.setState({ loading: true, paginacion, sort, filters });

    this.props.data(paginacion, this.getSort(sort), filters?.filters)
      .then(data => {
        console.log("GRID - DATA ARRIVED", data)
        this.setState({ data: data });
        if (!data.success)
          Alert.show({ severity: 'error', summary: 'Error al Obtener los Datos', detail: `${data.error}`, life: 5000 });
      })
      .catch(err => {
        console.error("GRID - ERROR", err, `${err}`);
        Alert.show({ severity: 'error', summary: 'Error Inesperado al Obtener datos para la Grilla', detail: `${err}`, life: 5000 })
      })
      .finally(() => this.setState({ loading: false }));
  }

  toogleColumn = (key: string) => {
    let { activecolumns } = this.state;

    if (activecolumns?.find(p => p.key === key)) {
      activecolumns = activecolumns.filter(p => p.key !== key).slice(0);
    } else {
      const col = this.state.allcolumns?.find(p => p.key === key);
      if (activecolumns && col)
        activecolumns.push(col);
    }

    UserData.set(`grid_${this.state.name ?? window.location.pathname}`, activecolumns?.map(p => ({ key: p.key, order: p.order })));
    this.setState({ activecolumns });
  }

  onColReorder = (keys: string[]) => {
    let { activecolumns } = this.state;

    for(let i = 0; i<= keys.length; i++) {

      const key = keys[i];
      const col = activecolumns?.find(p => p.key === key);
      if (col)
        col.order = i;
    }
    UserData.set(`grid_${this.state.name ?? window.location.pathname}`, activecolumns?.map(p => ({ key: p.key, order: p.order })));
  }

  export = () => {
    let { sort, filters } = this.state;
    this.setState({ loading: true });
    const COL_SEPARATOR = ';';

    this.props.data(undefined, this.getSort(sort), filters?.filters)
      .then(data => {
        if (!data.success)
          Alert.show({ severity: 'error', summary: 'Error al Obtener los Datos', detail: `${data.error}`, life: 5000 });
        
        const { activecolumns } = this.state;
        
        // content
        let content = data.data?.map(d => { // row x row
          let res = "";
          if (activecolumns) {
            for(let i = 0; i < activecolumns.length; i++) { // columna por columna
              const col = activecolumns[i]?.column;
              if (!col) continue;
              if (!!col.hideForExport) continue;

              let txt = "";
              if (!!col.export) txt = `${col.export(d) ?? ''}`;
              else if (!!col.field) txt = d[col.field] ? d[col.field] : "";

              if (typeof col.exportNewLineChar === 'string') txt = txt.replace(/(\r\n|\n|\r)/g, col.exportNewLineChar);

              res += txt + COL_SEPARATOR;
            }
          }

          return res.length > 0 ? res.substr(0, res.length - COL_SEPARATOR.length) + "\n" : "";
        });

        // cabecera
        let header = "#";
        if (activecolumns) {
          for(let i = 0; i < activecolumns?.length; i++) {
            const ca = activecolumns[i];
            if (ca.column) {
              header += ca.column.header + COL_SEPARATOR;
            }
          }
          header = header.length > 0 ? header.substr(0, header.length-1) + "\n" : "";
        }
        // genero el archivo
        var blob = new Blob([...[header], ...(content ?? [])], { type: 'text/csv;charset=utf-8' });
        saveAs(blob, "export.csv");
      })
      .catch(err => Alert.show({ severity: 'error', summary: 'Error Inesperado al Obtener datos para la Exportación', detail: `${err}`, life: 5000 }))
      .finally(() => this.setState({ loading: false }));
  }

  drawCardRow = (row: any, col: any) : JSX.Element => {
    const { activecolumns } =  this.state;
    const cardInfo = (activecolumns ?? []).sort((a,b) => a.order - b.order).filter(p => !!p.column).map(c => 
      <div className={styles['card-row']}>
        <div className={styles['card-row-header']}>{c.column?.header}</div>
        <div className={styles['card-row-value']}>{c.column?.body ? c.column.body(row,col) : <>{eval(`row.${c.column?.field}`)}</>}</div>
      </div>);
    const buttons = (activecolumns ?? []).sort((a,b) => a.order - b.order).filter(p => !!p.commands).map(c => 
      <div className={styles['card-footer']}>
        {c.commands?.filter(b => !b.hide || b.hide(row) === false).map(b => 
          <Button 
            type="button" 
            icon={b.icon} 
            label={b.label}
            onClick={() => b.onClick && b.onClick(row, this)} 
            tooltip={b.tooltip} 
            tooltipOptions={{position:'top'}}
            className={`${styles.columnButton} ${b.className}`}
            style={b.style}
            disabled={b.disabled && b.disabled(row)}
          />
        )}
      </div>);

    return <>{cardInfo}{buttons}</>;
  }

  /** Actualiza los datos de la grilla con la configuración actual */
  refresh() {
    this.getData();
  }
  refreshColumns() {
    this.getUserConfig(false);
  }
  setColumns(columns: IGridColumn[]) {
    this.setState({ columns }, () => this.getUserConfig(false));
  }

  render() {
    const This = this;
    const { headerCommands, allcolumns, activecolumns, footer, children, data, loading, paginacion, selectMode, selected, orderMode, sort, filters, editorMode, customProps } = this.state;
    const { onSelect, refTable } = this.props;
    return (
      <Loader loading={loading}>
        <div className={styles["datatable-responsive"]}>
          <DataTable 
            // comportamiento
            ref={refTable}
            lazy
            rowHover
            className={this.state.className}

            // Misc
            header={this.state.customHeader ? this.state.customHeader :
              <Toolbar
                style={{ border: 0, padding: 0 }}
                left={() =>
                  <React.Fragment>
                    <Button type="button" onClick={(e) => this.GridOptionsPanel && this.GridOptionsPanel.show(e, e.target)} className="p-button-outlined p-button-raised p-button-rounded" icon="pi pi-ellipsis-h" tooltip="Opciones de Columna" tooltipOptions={{position:'bottom'}} style={{ marginRight: '.5em', fontSize: '0.8em' }}></Button>
                    {headerCommands && headerCommands.filter(c => !!c).map(c => 
                      !!c?.body ? <>{c.body()}</> : <Button onClick={(e: any) => c && c.onClick && c.onClick(e, This)} type="button" icon={c?.icon} label={c?.label} className={c?.className ? c?.className : "c-button-new"} style={c?.style} tooltip={c?.tooltip} tooltipOptions={{ position: 'bottom'}} />
                    )}
                  </React.Fragment>
                }
                right={() =>
                  <React.Fragment>
                    <Button type="button" icon="fab fa-youtube" className="p-button-raised p-button-danger p-button-text" onClick={() => this.setState({ showvideo: true })}/>
                    <Button type="button" icon="fas fa-download" className="p-button-raised p-button-secondary p-button-text" tooltip="Exportar a CSV" tooltipOptions={{position:'bottom'}} onClick={() => this.export() }/>
                  </React.Fragment>
                }
              />
            }
            headerColumnGroup={this.state.headerColumnGroup}
            footer={footer}
            //reorderableColumns
            resizableColumns
            columnResizeMode="fit"
            //onColReorder={e => this.onColReorder(e.columns.map((c : any) => c.props.columnKey))}

            contextMenuSelection={this.state.contextMenuSelection}
            onContextMenuSelectionChange={e => this.setState({ contextMenuSelection: e.value })}
            onContextMenu={e => this.props.onContextMenu && this.props.onContextMenu(e, this.state.contextMenuSelection)}
            onRowDoubleClick={e => this.props.onRowDoubleClick && this.props.onRowDoubleClick(e)}

            // Datos
            dataKey={this.state.dataKey ?? "id"}
            value={window.ms_castA<any>(data?.data) ?? []}

            // Paginación
            paginator 
            rows={paginacion?.pageSize}
            first={paginacion ? (paginacion.pageIndex * paginacion.pageSize) : 0}
            totalRecords={data?.total}
            emptyMessage="No se encontraron Datos" 
            currentPageReportTemplate="Mostrando Registros de {first} a {last} de un total de {totalRecords}"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" 
            rowsPerPageOptions={[10,25,50, 100, 250]}
            onPage={(e : any) => this.getData(e.page, e.rows)}

            // Selection
            selectionMode={selectMode}
            selection={selected}
            onSelectionChange={e => { this.setState({ selected: e.value }); onSelect && onSelect(e.value); }}

            // Sort
            removableSort
            sortMode={orderMode}
            sortField={sort?.sortField}
            sortOrder={sort?.sortOrder}
            multiSortMeta={sort?.multiSortMeta}
            onSort={(e : any) => this.getData(undefined, undefined, e)}

            // Filters
            filters={filters?.filters}
            onFilter={(e : any) => this.getData(undefined, undefined, undefined, e)}

            editMode={editorMode}
            {...customProps}
          >
            {activecolumns?.sort((a,b) => a.order - b.order).map(c => 
              c.column ?
              <Column 
                className={styles["column-grid"]}
                key={c.key} 
                columnKey={c.key}
                field={c.column.field} 
                header={c.column.header} 
                sortable={c.column.sortable} 
                filter={c.column.filter} 
                filterHeaderClassName="p-column"
                filterElement={c.column.filterElement}
                filterPlaceholder={c.column.filterPlaceholder}
                body={c.column.body}
                style={c.column.style}

                editor={c.column.editorBody}
                onEditorCancel={c.column.onEditorCancel}
                onEditorSubmit={c.column.onEditorSubmit}
              /> :
              <Column 
                className={styles["column-grid"]}
                columnKey={c.key}
                body={(row: any, col: any) => (
                  <div>
                    { c.commands?.map(c => 
                      (c.hide === undefined || c.hide(row) === false) &&
                      (<Button 
                        type="button" 
                        icon={c.icon} 
                        label={c.label}
                        onClick={() => c.onClick && c.onClick(row, This)} 
                        tooltip={c.tooltip} 
                        tooltipOptions={{position:'left'}}
                        className={`${styles.columnButton} ${c.className}`}
                        style={c.style}
                        disabled={c.disabled && c.disabled(row)}
                      />))
                    }
                  </div>
                )}
                headerStyle={{ width: !this.state.columnCommandsWidth ? `${((c.commands?.length ?? 1) * 44) + 27}px` : this.state.columnCommandsWidth }}
                style={{textAlign:'center', minWidth: !this.state.columnCommandsWidth ? `${((c.commands?.length ?? 1) * 44) + 27}px` : this.state.columnCommandsWidth}}
              />
            )}
            {children}
            <Column className={`${styles["column-card"]} ${(data?.data ?? []).length < 1 ? styles["column-card-empty"] : ''}`} body={this.drawCardRow}></Column>
          </DataTable>
        </div>

        <OverlayPanel ref={(el) => this.GridOptionsPanel = el} dismissable className={styles["panel-columnas"]} style={{ marginTop: 20, marginLeft: -11 }} appendTo={(window as any).mainbody}>
          <label>Columnas</label>
          {allcolumns?.map(o => 
            <div style={{display:'block', height: 25, margin: 4}}>
              <InputSwitch 
                checked={activecolumns?.find(p => p.key === o.key) && true}
                tooltip={`Muestra u Oculta la columna ${o.column?.header ?? "de acciones"}`}
                tooltipOptions={{ position: 'bottom'}}
                onChange={e => this.toogleColumn(o.key)}
              />
              <div style={{display: 'inline', verticalAlign: 'top', marginLeft: 10, marginTop: 3}}>{o.column?.header ?? "Acciones"}</div>
            </div>
          )}
          <Button icon="pi pi-refresh" className="p-button-raised p-button-secondary" label="Reset" style={{ marginTop: 8 }} onClick={() => this.getUserConfig(true)} tooltip="Restaura las columnas al estado por default" tooltipOptions={{position: 'bottom'}} />
        </OverlayPanel>
        <Dialog 
          visible={this.state.showvideo}
          onHide={() => this.setState({ showvideo: false })}
        >
          <Player url="/videos/component.grid.mp4" autoplay />
        </Dialog>
      </Loader>
    );
  }
}

const gridDataNoop = (pag?: IPagination, sort?: string, filters?: any) : Promise<IPaginatedResponse<any>> => 
  new Promise<IPaginatedResponse<any>>((res,rej) => res({ pageIndex: 0, total: 0, data: [], success: true }));

export default connect((s:any) => ({ storage:s.main }))(Index);
export { Index, SelectModes, OrderModes }
export { gridDataNoop }
export type { IPagination, IGridColumn, IGridCommand, DataTableRowEventParams, DataTableRowClickEventParams }
export { getDataFromArray } from './service';
